import React from 'react'
import './App.css'

function Footer() {

    return (
        <div  className="footer">
                     <h1 className="footer_copy">by Scott Jellen &#169; 2020</h1>
        </div>   
    )
}

export default Footer